export default __webpack_public_path__ + "static/media/filters-white.20241086.svg";